export class AbortWaitError extends Error {
  constructor() {
    super('Wait Aborted');
  }
}

const sleep = (
  ms: number,
  options?: { abortSignal?: AbortSignal },
): Promise<void> => {
  if (options?.abortSignal?.aborted) {
    return Promise.reject(new AbortWaitError());
  }
  return new Promise((resolve, reject) => {
    const abortHandler = () => {
      clearTimeout(timeout);
      reject(new AbortWaitError());
    };
    const timeout = setTimeout(() => {
      options?.abortSignal?.removeEventListener('abort', abortHandler);
      resolve();
    }, ms);
    options?.abortSignal?.addEventListener('abort', abortHandler);
  });
};

export default sleep;
